import { Check } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { useI18n } from "@/lib/i18n";

const SERVICE_KEYS = [
    { id: "property", image: BRAND.images.property },
    { id: "concierge", image: BRAND.images.concierge },
    { id: "events", image: BRAND.images.events },
];

export default function Services() {
    const { t } = useI18n();
    return (
        <section id="services" data-testid="services-section" className="relative py-28 md:py-40 bg-[#050D1C]">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="eyebrow">{t("services.eyebrow")}</span>
                    <h2 className="font-serif-display text-white text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
                        {t("services.title_a")} <br />{" "}
                        <em className="not-italic text-[#C9A96E]">{t("services.title_highlight")}</em>
                    </h2>
                    <p className="mt-8 text-slate-400 max-w-2xl leading-relaxed">{t("services.subtitle")}</p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {SERVICE_KEYS.map((s, i) => {
                        const items = t(`services.${s.id}.items`);
                        const list = Array.isArray(items) ? items : [];
                        return (
                            <article
                                key={s.id}
                                id={s.id}
                                data-testid={`service-card-${s.id}`}
                                className="reveal glass-card overflow-hidden group flex flex-col"
                                style={{ transitionDelay: `${i * 80}ms` }}
                            >
                                <div className="relative h-64 overflow-hidden">
                                    <img
                                        src={s.image}
                                        alt={t(`services.${s.id}.title`)}
                                        className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#050D1C] via-[#050D1C]/40 to-transparent" />
                                    <span className="absolute top-4 left-4 eyebrow bg-[#050D1C]/60 backdrop-blur-md px-3 py-1.5 border border-[#C9A96E]/30">
                                        {t(`services.${s.id}.eyebrow`)}
                                    </span>
                                </div>
                                <div className="p-8 md:p-10 flex flex-col flex-1">
                                    <h3 className="font-serif-display text-white text-3xl">{t(`services.${s.id}.title`)}</h3>
                                    <p className="mt-4 text-slate-400 text-[15px] leading-relaxed">{t(`services.${s.id}.blurb`)}</p>
                                    <ul className="mt-6 space-y-3">
                                        {list.map((it) => (
                                            <li key={it} className="flex items-start gap-3 text-slate-300 text-sm">
                                                <Check size={16} className="text-[#C9A96E] mt-0.5 shrink-0" />
                                                <span>{it}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="mt-8 pt-6 border-t border-[#C9A96E]/15">
                                        <button
                                            data-testid={`service-cta-${s.id}`}
                                            onClick={() =>
                                                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })
                                            }
                                            className="text-[11px] tracking-[0.28em] uppercase text-[#C9A96E] hover:text-white transition-colors"
                                        >
                                            {t("services.cta_consult")}
                                        </button>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
